


































































































































































































import { Component, Vue } from "vue-property-decorator";
import NewsItem from "@/components/NewsItem.vue";
import Zan from "@/components/Zan.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import CommentItem from "@/components/CommentItem.vue";
import { ICommentItem } from "@/api/types";
import request from "@/api/wanzhou/index";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import {
  dateFormat,
  setImgSrc,
  findNameByIdInApp,
  findNameByWechatAppid
} from "@/common/Utils";
import { IVideoDetail } from "@/api/wanzhou/types";
import nopage from "@/components/404.vue";
import {
  IShareConfig,
  IShareConfigItem,
  IComment,
  IHot,
  ICommonItem
} from "@/api/types";
import posterV2 from "@/components/posterV2.vue";
import { Base64 } from "js-base64";
import {
  Toast,
  Dialog,
  Icon,
  ImagePreview,
  List,
  PullRefresh,
  Loading
} from "vant";
// import { AppInfo } from "@/common/baseConfig";
import { wxChatShare } from "@/common/wechat";
import ImageViewCom from "@/components/imageViewCom.vue";
import { getData, time } from "@/common/dataCollect";
import DownloadFile from "@/components/Download.vue";
@Component({
  components: {
    NewsItem,
    CommentItem,
    vanIcon: Icon,
    Zan,
    AppPrompt,
    VanList: List,
    VanPullRefresh: PullRefresh,
    VanLoading: Loading,
    nopage,
    ImageViewCom,
    posterV2,
    DownloadFile
  }
})
export default class GraphicPage extends Base {
  private newsList: object[] = [];
  private newsInfo: any = {};
  private commentList: ICommentItem[] = [];
  private newsId?: number;
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  //
  private isLoading: boolean = false;
  private loading: boolean = false;
  private finished: boolean = false;
  private lastCreateTime: string = "";
  private lastReplyId?: number;
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  public request = new request();
  public appId: string = "";
  private downloadUrl: string = "";
  private appName: string = "";
  private isOpenInApp: boolean = false;
  private isShowAppPromt: boolean = true;
  private isRequestLoaded: boolean = false; //详情是否加载完成
  private isNoPlay: boolean = true;
  private isPlayAudio: boolean = false;
  ImgSrcArr: any = [];
  wxAppId: any;

  get isShowZan() {
    if (["2544889", "2548974"].includes(this.infoClassifyId)) {
      return false;
    }
    return true;
  }
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  openhdstatic: any; // 是否显示头部唤醒 - 最高优先级  1显示  2不显示
  created() {
    this.startTime = time();
  }
  mounted() {
    let bigSize = this.$route.query.bigSize as string;
    let appEle: HTMLElement | null = document.getElementById("app");
    if (appEle) {
      if (bigSize == "1") {
        appEle.classList.add("wzsb_font_size_big");
      }
    }
    (this.$route.query.openhdstatic as string) == "2"
      ? (this.openhdstatic = false)
      : (this.openhdstatic = true);
    //调试
    // let vConsole = new VConsole();
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "";
    this.appId = (this.$route.query.appId as string) || "";
    this.appName = findNameByIdInApp(this.$store.state.appInfo, this.appId); //enum 反向映射
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    //假的userInfo
    // this.userInfo = {
    //   appId: this.appId,
    //   sessionId: "68ad409040054938b4e53e5612a8124c",
    //   token: "03d24c7f4c6a48f3af3d667d8d1aca4a",
    // };
    if (native.isOpenInApp()) {
      this.isOpenInApp = true;
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getDetail();
      });
    } else {
      this.isOpenInApp = false;
      this.getDetail();
    }
    this.getNewsList();
  }
  // meta and title 逻辑还未添加，此处无效
  metaInfo(): any {
    return {
      title: "12312das",
      meta: [
        {
          name: "keyWords",
          content: "custom"
        }
      ]
    };
  }
  /**新闻详情 */
  getDetail() {
    this.request
      .getInfoDetailNew(this.infoClassifyId)
      .then((response: IVideoDetail) => {
        if (response.code >= 0) {
          this.newsInfo = response.data;
          this.newsId = response.data.id;
          //满足单段空两格字符
          this.newsInfo.content = this.newsInfo.content;
          //设置title
          document.title = this.newsInfo.title;
          this.isRequestLoaded = true;

          this.$nextTick(() => {
            setImgSrc(this.$refs.newsContent as Element);
            // 音频播放问题  因为来自富文本 只能这样解决
            let audiosImg = document.querySelector(
              ".detail_audio .detail_audio_img"
            ) as HTMLElement;
            audiosImg &&
              audiosImg.addEventListener(
                "click",
                function(e) {
                  this.style.display = "none";
                  let audio =
                    this.parentNode && this.parentNode.querySelector("audio");
                  audio && audio.play();
                },
                false
              );
            this.isLoading = false;
            this.imageHandle(); // 图片预览等功能
            this.lazyHandle(); // 图片懒加载
            this.handleTouch();
            this.handleVideo();
          });

          // this.getCommentList();
          this.getBussinessDetail();

          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.detailGetAppId = this.newsInfo.appId;

          this.getBaseappInfoConfigList(this.newsInfo.appId);

          this.$nextTick(() => {
            this.getCount();
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.newsInfo);
              this.dataSource = false;
            }
          });
        } else {
          this.isRequestLoaded = true;
        }
      })
      .catch(() => {
        // 修改isRequestLoaded状态为何不用finally  是因为后面的懒加载要拿页面元素，必须提前让元素显示出来
        this.isRequestLoaded = true;
      });
  }

  handleTouch() {}
  openViewChild(index: any) {
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  imageHandle() {
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".news-content img") as NodeListOf<HTMLElement>,
      0
    );
    const srcArr: Array<string> = elements.map(
      v => v.getAttribute("data-original") as string
    );
    this.ImgSrcArr = srcArr;
    let th = this;
    elements.forEach((v, i) => {
      (function(i) {
        v &&
          v.addEventListener(
            "click",
            function(e) {
              th.openViewChild(i);
            },
            false
          );
      })(i);
    });
  }
  /**热点列表 */
  getNewsList() {
    this.request
      .getHotList(this.infoClassifyId, this.appId)
      .then((response: IHot) => {
        if (response.code >= 0) {
          this.newsList = response.data.dataList;
        }
      });
  }
  /**评论列表 */
  getCommentList(isClear = true) {
    if (isClear) {
      // 如果要清除所有，重新加载，需要重置到第一页
      this.lastCreateTime = "";
      this.lastReplyId = undefined;
    }
    this.request
      .getCommentListPage(
        this.appId,
        this.userInfo.sessionId,
        this.newsInfo.id,
        "1",
        this.lastCreateTime,
        this.lastReplyId,
        this.userInfo.token
      )
      .then((response: IComment) => {
        if (response.code >= 0) {
          if (isClear) {
            this.commentList = [];
          }
          if (response.data.dataList.length === 0) {
            this.finished = true;
          } else {
            this.commentList = this.commentList.concat(response.data.dataList);
            this.isLoading = false;
            this.loading = false;
            this.lastCreateTime = response.data.dataList.lastChild
              .createTime as string;
            this.lastReplyId = response.data.dataList.lastChild.replyId;
          }
        }
      })
      .catch(e => {
        this.finished = true;
        this.commentList = [];
      });
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response && response.data) {
          this.businessDetail.isPraised = response.data.isPraised;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  /**评论点赞 */
  doPraise(item: ICommentItem) {
    if (this.isOpenInApp) {
      native.goToken().then(res => {
        this.userInfo = res;
        this.request
          .doPraise(
            this.infoClassifyId,
            this.appId,
            this.userInfo.sessionId,
            item.replyId,
            1,
            "1",
            1,
            this.userInfo.token,
            new Date().getTime()
          )
          .then((response: any) => {
            if (response.code >= 0) {
              if (response.data) {
                this.getCommentList();
                //积分
                if (response.data.point && response.data.point > 0) {
                  try {
                    ZWY_CLOUD.showPointView({
                      message: "点赞成功！",
                      point: response.data.point
                    });
                  } catch (e) {
                    ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                  }
                } else {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              }
            } else {
              if (response.code === -999992) {
                native.goToken().then(res => {
                  this.userInfo = res;
                });
              } else if (response.code === -101000134) {
                native.goForceToken().then(res => {
                  this.userInfo = res;
                });
              } else {
                ZWY_CLOUD.appAlert({ message: response.message });
              }
            }
          })
          .catch((error: any) => {
            ZWY_CLOUD.appAlert({ message: error.toString() });
          });
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsInfo);
      });
    }
  }
  /**新闻点赞 */
  articleDoPraise() {
    if (this.isOpenInApp) {
      native.goToken().then(res => {
        this.userInfo = res;
        this.request
          .doPraise(
            this.infoClassifyId,
            this.appId,
            this.userInfo.sessionId,
            this.newsInfo.informationId, // 暂时的评论id
            1,
            "1", // version
            0,
            this.userInfo.token,
            new Date().getTime()
          )
          .then((response: any) => {
            if (response.code >= 0) {
              if (response.data) {
                // 假点赞成功-图标变红和+1
                this.businessDetail.isPraised = true;
                isNaN(Number(this.businessDetail!.praiseCount))
                  ? ""
                  : (this.businessDetail!.praiseCount =
                      Number(this.businessDetail!.praiseCount) + 1);
                //积分
                if (response.data.point && response.data.point > 0) {
                  try {
                    ZWY_CLOUD.showPointView({
                      message: "点赞成功！",
                      point: response.data.point
                    });
                  } catch (e) {
                    ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                  }
                } else {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              }
            } else {
              if (response.code === -999992) {
                native.goToken().then(res => {
                  this.userInfo = res;
                });
              } else if (response.code === -101000134) {
                native.goForceToken().then(res => {
                  this.userInfo = res;
                });
              } else {
                ZWY_CLOUD.appAlert({ message: response.message });
              }
            }
          });
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsInfo);
      });
    }
  }
  /**到详情页 */
  toCommentDetail() {
    let param = {
      id: this.infoClassifyId,
      informationId: this.newsInfo.informationId,
      sourceType: this.newsInfo.sourceType,
      newsCommentType: this.newsInfo.commentType
    };
    let jsonParam: any = {
      iOS: "CQCommentDetailController",
      Android: "goToFamous",
      par: param
    };
    if (native.isOpenInApp()) {
      native.pushToController(jsonParam);
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsInfo);
      });
    }
  }
  //图片预览
  toImagePreview(item: any) {
    if (native.isOpenInApp()) {
      native.viewImageContent({
        array: [
          {
            imgUrl: item.imageUrl,
            desc: ""
          }
        ],
        index: 0
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsInfo);
      });
    }
  }
  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "0",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      var val = "";
      if (this.$route.query.bigSize != null) {
        val = "&bigSize=" + this.$route.query.bigSize;
      }
      window.location.href = item.url + val;
    }
  }
  //懒加载处理
  lazyHandle() {
    //图片视频的懒加载
    class LazyImage {
      private imageElements: Array<Element> = [];
      private _throttleFn: any;
      constructor() {
        this.imageElements = Array.prototype.slice.call(
          document.querySelectorAll(".news-content img[data-original]")
        );
        this.init();
      }
      init() {
        this.inViewShow();
        this._throttleFn = this.throttle(this.inViewShow);
        addEvent(
          document.querySelector("#app"),
          "scroll",
          this._throttleFn.bind(this),
          false
        );
        // }
      }
      inViewShow() {
        let len = this.imageElements.length;
        // console.log("scroll");
        for (let i = 0; i < len; i++) {
          let imageElement = this.imageElements[i];
          let rect = imageElement.getBoundingClientRect();
          // 出现在视野的时候加载图片
          if (rect.top < document.documentElement.clientHeight) {
            let dataSrc = imageElement.getAttribute("data-original") as string;
            dataSrc && imageElement.setAttribute("src", dataSrc);
            imageElement.removeAttribute("data-original");
            // 移除掉已经显示的
            this.imageElements.splice(i, 1);
            len--;
            i--;
            if (this.imageElements.length === 0) {
              // 如果全部都加载完 则去掉滚动事件监听
              // document.removeEventListener('scroll', this._throttleFn)
              removeEvent(document, "scroll", this._throttleFn, false);
            }
          }
        }
      }
      throttle(fn: any, delay: number = 15, mustRun: number = 30) {
        let t_start: number | null = null;
        let timer: any = null;
        let context = this;
        return function() {
          let t_current = +new Date();
          let args = Array.prototype.slice.call(arguments);
          clearTimeout(timer);
          if (!t_start) {
            t_start = t_current;
          }
          if (t_current - t_start > mustRun) {
            fn.apply(context, args);
            t_start = t_current;
          } else {
            timer = setTimeout(function() {
              fn.apply(context, args);
            }, delay);
          }
        };
      }
    }
    new LazyImage();
    //兼容IE浏览器
    // 事件绑定
    function addEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        //如果支持addEventListener
        element.addEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        //如果支持attachEvent
        element.attachEvent("on" + eType, handle);
      } else {
        //否则使用兼容的onclick绑定
        element["on" + eType] = handle;
      }
    }
    // 事件解绑
    function removeEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        element.removeEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eType, handle);
      } else {
        element["on" + eType] = null;
      }
    }
  }
  onRefresh() {
    this.lastCreateTime = "";
    this.lastReplyId = undefined;
    this.finished = false;
    this.getDetail();
  }
  onLoad() {
    if (this.newsId) {
      this.getCommentList(false);
    }
  }
  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }
  // 播放语音播报
  playVoice() {
    const ele = this.$refs.audioEle as HTMLAudioElement;
    this.isNoPlay = false;
    if (!this.isPlayAudio) {
      ele && ele.play();
      this.isPlayAudio = true;
    } else {
      ele && ele.pause();
      this.isPlayAudio = false;
    }
  }
  wxopenApp() {
    (this.$refs.openapp_prompt as any).openApp();
  }
}
